import React from "react";
import { Box, Typography } from "@mui/material";
import useUser from "../../hooks/useUser";
import background from "../../assets/svg/AuthBgDark.svg";
import logo from "../../assets/png/LogoWhite.png";
import { useTranslation } from "react-i18next";
export const heroHeight = "35vh";

export default function Hero({height = heroHeight}) {
  const { profile } = useUser();
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        minHeight: height,
        backgroundImage: `url(${background})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      mb={5}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight={height}
        textAlign="center"
      >
        <img src={logo} width="550px" alt="Logo" />
        <Typography variant="h6" sx={{ color: "white" }}>
          {t("WelcomeBack")}, {profile.firstName}
        </Typography>
      </Box>
    </Box>
  );
}
